"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return !isNaN(date.getTime());
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/isDateValid.js
// module id = 63
// module chunks = 0